import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import styled from 'styled-components';
import { withUser, IWithUserProps } from 'src/services/withUser';
import { getAdminPages } from 'src/services/getAdminPages';

interface ISidebarLink extends LinkProps {
  active: boolean;
}
interface IAdminNavProps extends IWithUserProps {
  current: string;
}

const StyledLink = styled(Link)<{ active: string }>`
  border-color: ${props =>
    props.active === 'true' ? props.theme.primary : '#A7A9A9'};
  &:hover {
    border-color: ${props => props.theme.primary};
  }
`;

const SidebarLink = ({ to, children, active }: ISidebarLink) => (
  <StyledLink
    active={String(active)}
    className={`${
      active ? 'bg-grey-dark' : 'hover:bg-grey-dark'
    } block px-6 py-3 text-black text-lg border-l-2 whitespace-no-wrap`}
    to={to}
  >
    {children}
  </StyledLink>
);

const AdminNav = ({ user, current }: IAdminNavProps) => (
  <nav>
    <ul className="list-reset sticky pin-l pin-t">
      {getAdminPages(user.roles).map(({ path, name }) => (
        <li key={path}>
          <SidebarLink to={path} active={current === path}>
            {name}
          </SidebarLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default withUser(AdminNav);



// WEBPACK FOOTER //
// ./src/views/Admin/components/AdminNav.tsx